var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cms-navigation-block",
      class: _vm.rootClasses,
      style: _vm.rootStyle,
    },
    [
      _vm.isMobileLayout
        ? _c(
            "div",
            {
              staticClass: "cms-nav__mobile-bar",
              class: {
                "cms-nav__mobile-bar--inline": !_vm.isOn(_vm.showMobileBar),
              },
              style: _vm.mobileBarComputedStyle,
            },
            [
              _c(
                "a",
                {
                  staticClass: "cms-nav__mobile-logo",
                  style: _vm.mobileLogoStyle,
                  attrs: { href: _vm.logoUrl || "/" },
                },
                [
                  _vm.resolvedLogoSrc
                    ? _c("img", {
                        style: _vm.logoImgStyle,
                        attrs: { src: _vm.resolvedLogoSrc, alt: _vm.siteName },
                      })
                    : _c(
                        "span",
                        {
                          staticClass: "cms-nav__mobile-sitename",
                          style: _vm.mobileSitenameStyle,
                        },
                        [_vm._v(_vm._s(_vm.siteName || "Home"))]
                      ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cms-nav__mobile-actions" }, [
                _vm.isOn(_vm.showSearch)
                  ? _c(
                      "button",
                      {
                        staticClass: "cms-nav__mobile-toggle",
                        style: _vm.mobileToggleStyle,
                        attrs: {
                          type: "button",
                          "aria-label": _vm.t("navigation.search"),
                          "data-testid": "cms-nav-search-open",
                        },
                        on: { click: _vm.openSearch },
                      },
                      [_c("i", { staticClass: "fa fa-search" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "cms-nav__mobile-toggle",
                    style: _vm.mobileToggleStyle,
                    attrs: {
                      type: "button",
                      "aria-expanded": _vm.mobileOpen ? "true" : "false",
                      "aria-label": _vm.t("navigation.toggleMenu"),
                    },
                    on: { click: _vm.toggleMobile },
                  },
                  [
                    _c("i", {
                      class: [
                        "fa",
                        _vm.mobileOpen
                          ? "fa-times"
                          : _vm.mobileToggleIcon || "fa-bars",
                      ],
                    }),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobileLayout && _vm.isOn(_vm.showMobileBar)
        ? _c("div", {
            staticClass: "cms-nav__mobile-spacer",
            style: { height: _vm.mobileBarHeight },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobileLayout
        ? _c(
            "nav",
            {
              staticClass: "cms-nav__desktop",
              class: _vm.desktopNavClasses,
              style: _vm.desktopNavComputedStyle,
            },
            [
              _vm.showDesktopLogo
                ? _c(
                    "a",
                    {
                      staticClass: "cms-nav__desktop-logo",
                      style: _vm.desktopLogoStyle,
                      attrs: { href: _vm.logoUrl || "/" },
                    },
                    [
                      _vm.resolvedLogoSrc
                        ? _c("img", {
                            style: _vm.logoImgStyle,
                            attrs: {
                              src: _vm.resolvedLogoSrc,
                              alt: _vm.siteName,
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "cms-nav__desktop-sitename",
                              style: _vm.desktopSitenameStyle,
                            },
                            [_vm._v(_vm._s(_vm.siteName || "Home"))]
                          ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "cms-nav__list cms-nav__list--root",
                  style: _vm.rootListStyle,
                },
                _vm._l(_vm.topLevelItems, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.id,
                      staticClass: "cms-nav__item",
                      class: [
                        "cms-nav__item--" + item.type,
                        {
                          "cms-nav__item--has-children": _vm.opensPanel(item),
                          "cms-nav__item--mega": _vm.isMegaItem(item),
                          "cms-nav__item--active": _vm.isActiveItem(item),
                        },
                      ],
                      on: {
                        mouseenter: function ($event) {
                          return _vm.hoverEnter(item.id)
                        },
                        mouseleave: function ($event) {
                          return _vm.hoverLeave(item.id)
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          class: [
                            "cms-nav__link",
                            {
                              "cms-nav__link--has-children":
                                _vm.opensPanel(item),
                              "cms-nav__link--active": _vm.isActiveItem(item),
                            },
                            item.cssClass,
                          ],
                          style: _vm.computedLinkStyle(item),
                          attrs: {
                            href: _vm.safeUrl(item.url),
                            target: item.target || "_self",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onLinkClick(item, $event)
                            },
                          },
                        },
                        [
                          item.icon
                            ? _c("i", {
                                class: ["fa", item.icon, "cms-nav__icon"],
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "cms-nav__label" }, [
                            _vm._v(_vm._s(item.label)),
                          ]),
                          _vm._v(" "),
                          item.badgeText
                            ? _c(
                                "span",
                                {
                                  staticClass: "cms-nav__badge",
                                  style: _vm.badgeStyle(item),
                                },
                                [_vm._v(_vm._s(item.badgeText))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.opensPanel(item)
                            ? _c("i", {
                                class: ["fa", _vm.caretIcon, "cms-nav__caret"],
                                style: _vm.caretComputedStyle,
                              })
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isMegaItem(item) && _vm.isOpen(item.id)
                        ? _c(
                            "div",
                            {
                              staticClass: "cms-nav__mega",
                              class: [
                                "cms-nav__mega--" +
                                  (item.megaLayout || _vm.megaDefaultCols),
                                {
                                  "cms-nav__mega--page":
                                    _vm.megaSpan === "page",
                                },
                              ],
                              style: _vm.megaPanelComputedStyle,
                            },
                            [
                              _vm.megaOf(item)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cms-nav__mega-grid cms-nav__mega-grid--built",
                                      style: {
                                        gridTemplateColumns: _vm.megaGrid(item),
                                      },
                                    },
                                    _vm._l(
                                      _vm.megaOf(item).columns,
                                      function (col, ci) {
                                        return _c(
                                          "div",
                                          {
                                            key: "c" + ci,
                                            staticClass: "cms-nav__mega-col",
                                          },
                                          [
                                            _vm._l(
                                              col.blocks,
                                              function (blk, bi) {
                                                return [
                                                  blk.type === "links"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: "b" + bi,
                                                          staticClass:
                                                            "cms-nav__mega-block cms-nav__mega-block--links",
                                                        },
                                                        [
                                                          blk.heading
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cms-nav__mega-heading",
                                                                  style:
                                                                    _vm.megaHeadingComputedStyle,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      blk.heading
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ul",
                                                            {
                                                              staticClass:
                                                                "cms-nav__mega-list",
                                                            },
                                                            _vm._l(
                                                              _vm.megaLinksFor(
                                                                item,
                                                                ci,
                                                                bi
                                                              ),
                                                              function (child) {
                                                                return _c(
                                                                  "li",
                                                                  {
                                                                    key: child.id,
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "cms-nav__mega-link",
                                                                        style:
                                                                          _vm.megaLinkComputedStyle,
                                                                        attrs: {
                                                                          href: _vm.safeUrl(
                                                                            child.url
                                                                          ),
                                                                          target:
                                                                            child.target ||
                                                                            "_self",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.onLinkClick(
                                                                                child,
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        child.icon
                                                                          ? _c(
                                                                              "i",
                                                                              {
                                                                                class:
                                                                                  [
                                                                                    "fa",
                                                                                    child.icon,
                                                                                  ],
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                child.label
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        child.description
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "cms-nav__mega-link-desc",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    child.description
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      )
                                                    : blk.type === "stories"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: "b" + bi,
                                                          staticClass:
                                                            "cms-nav__mega-block",
                                                        },
                                                        [
                                                          blk.heading
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cms-nav__mega-heading",
                                                                  style:
                                                                    _vm.megaHeadingComputedStyle,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      blk.heading
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cms-nav__mega-posts",
                                                              class:
                                                                "cms-nav__mega-posts--" +
                                                                (blk.layout ||
                                                                  "cards"),
                                                            },
                                                            [
                                                              _vm._l(
                                                                blk.posts || [],
                                                                function (p) {
                                                                  return _c(
                                                                    "a",
                                                                    {
                                                                      key: p.websitePostID,
                                                                      staticClass:
                                                                        "cms-nav__mega-post",
                                                                      style:
                                                                        _vm.megaLinkComputedStyle,
                                                                      attrs: {
                                                                        href: _vm.safeUrl(
                                                                          p.websitePostUrl
                                                                        ),
                                                                      },
                                                                    },
                                                                    [
                                                                      (blk.layout ||
                                                                        "cards") ===
                                                                        "cards" &&
                                                                      p.websitePostFeatureImageUrl
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "cms-nav__mega-post-img",
                                                                              style:
                                                                                {
                                                                                  backgroundImage:
                                                                                    "url('" +
                                                                                    p.websitePostFeatureImageUrl +
                                                                                    "')",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "cms-nav__mega-post-title",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              p.websitePostTitle
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              !(
                                                                blk.posts &&
                                                                blk.posts.length
                                                              )
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "cms-nav__mega-desc",
                                                                      style:
                                                                        _vm.megaDescComputedStyle,
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "No stories yet"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      )
                                                    : blk.type === "image"
                                                    ? _c(
                                                        blk.url ? "a" : "div",
                                                        {
                                                          key: "b" + bi,
                                                          tag: "component",
                                                          staticClass:
                                                            "cms-nav__mega-block cms-nav__mega-image",
                                                          attrs: {
                                                            href: blk.url
                                                              ? _vm.safeUrl(
                                                                  blk.url
                                                                )
                                                              : null,
                                                          },
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "cms-nav__mega-promo-img",
                                                            style: blk.src
                                                              ? {
                                                                  backgroundImage:
                                                                    _vm.bgImage(
                                                                      blk.src,
                                                                      640
                                                                    ),
                                                                }
                                                              : null,
                                                          }),
                                                          _vm._v(" "),
                                                          blk.caption
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "cms-nav__mega-desc",
                                                                  style:
                                                                    _vm.megaDescComputedStyle,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      blk.caption
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : blk.type === "text"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: "b" + bi,
                                                          staticClass:
                                                            "cms-nav__mega-block",
                                                        },
                                                        [
                                                          blk.heading
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cms-nav__mega-heading",
                                                                  style:
                                                                    _vm.megaHeadingComputedStyle,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      blk.heading
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          blk.html
                                                            ? _c("div", {
                                                                staticClass:
                                                                  "cms-nav__mega-desc cms-nav__mega-text",
                                                                style:
                                                                  _vm.megaDescComputedStyle,
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      blk.html
                                                                    ),
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : blk.type === "button"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: "b" + bi,
                                                          staticClass:
                                                            "cms-nav__mega-block",
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "cms-nav__mega-promo-btn",
                                                              class: {
                                                                "cms-nav__mega-promo-btn--outline":
                                                                  blk.style ===
                                                                  "outline",
                                                              },
                                                              attrs: {
                                                                href: _vm.safeUrl(
                                                                  blk.url || "#"
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  blk.label ||
                                                                    "Learn more"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : blk.type === "divider"
                                                    ? _c("hr", {
                                                        key: "b" + bi,
                                                        staticClass:
                                                          "cms-nav__mega-divider",
                                                      })
                                                    : _vm._e(),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "cms-nav__mega-grid" },
                                    _vm._l(item.children, function (child) {
                                      return _c(
                                        "div",
                                        {
                                          key: child.id,
                                          staticClass: "cms-nav__mega-col",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cms-nav__mega-heading",
                                              style:
                                                _vm.megaHeadingComputedStyle,
                                            },
                                            [_vm._v(_vm._s(child.label))]
                                          ),
                                          _vm._v(" "),
                                          child.description
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cms-nav__mega-desc",
                                                  style:
                                                    _vm.megaDescComputedStyle,
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(child.description)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.hasChildren(child)
                                            ? _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "cms-nav__mega-list",
                                                },
                                                _vm._l(
                                                  child.children,
                                                  function (grandchild) {
                                                    return _c(
                                                      "li",
                                                      { key: grandchild.id },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "cms-nav__mega-link",
                                                            style:
                                                              _vm.megaLinkComputedStyle,
                                                            attrs: {
                                                              href: _vm.safeUrl(
                                                                grandchild.url
                                                              ),
                                                              target:
                                                                grandchild.target ||
                                                                "_self",
                                                            },
                                                          },
                                                          [
                                                            grandchild.icon
                                                              ? _c("i", {
                                                                  class: [
                                                                    "fa",
                                                                    grandchild.icon,
                                                                  ],
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  grandchild.label
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            grandchild.description
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "cms-nav__mega-link-desc",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        grandchild.description
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                            ]
                          )
                        : _vm.hasChildren(item) && _vm.isOpen(item.id)
                        ? _c(
                            "ul",
                            {
                              staticClass:
                                "cms-nav__list cms-nav__list--dropdown",
                              style: _vm.dropdownComputedStyle,
                            },
                            _vm._l(item.children, function (child) {
                              return _c(
                                "li",
                                {
                                  key: child.id,
                                  staticClass:
                                    "cms-nav__item cms-nav__item--child",
                                  class: {
                                    "cms-nav__item--has-children":
                                      _vm.hasChildren(child),
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "cms-nav__link cms-nav__link--child",
                                      style: _vm.dropdownLinkComputedStyle,
                                      attrs: {
                                        href: _vm.safeUrl(child.url),
                                        target: child.target || "_self",
                                      },
                                    },
                                    [
                                      child.icon
                                        ? _c("i", { class: ["fa", child.icon] })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(child.label))]),
                                      _vm._v(" "),
                                      _vm.hasChildren(child)
                                        ? _c("i", {
                                            staticClass:
                                              "fa fa-chevron-right cms-nav__caret--child",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.hasChildren(child)
                                    ? _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "cms-nav__list cms-nav__list--submenu",
                                          style: _vm.dropdownComputedStyle,
                                        },
                                        _vm._l(
                                          child.children,
                                          function (grandchild) {
                                            return _c(
                                              "li",
                                              {
                                                key: grandchild.id,
                                                staticClass:
                                                  "cms-nav__item cms-nav__item--child",
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "cms-nav__link cms-nav__link--child",
                                                    style:
                                                      _vm.dropdownLinkComputedStyle,
                                                    attrs: {
                                                      href: _vm.safeUrl(
                                                        grandchild.url
                                                      ),
                                                      target:
                                                        grandchild.target ||
                                                        "_self",
                                                    },
                                                  },
                                                  [
                                                    grandchild.icon
                                                      ? _c("i", {
                                                          class: [
                                                            "fa",
                                                            grandchild.icon,
                                                          ],
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(grandchild.label)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.isOn(_vm.showSearch)
                ? _c(
                    "button",
                    {
                      staticClass: "cms-nav__search-btn",
                      style: _vm.searchBtnStyle,
                      attrs: {
                        type: "button",
                        "aria-label": _vm.t("navigation.search"),
                        title: _vm.t("navigation.search"),
                        "data-testid": "cms-nav-search-open",
                      },
                      on: { click: _vm.openSearch },
                    },
                    [_c("i", { staticClass: "fa fa-search" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ctaText
                ? _c(
                    "a",
                    {
                      staticClass: "cms-nav__cta",
                      style: _vm.ctaComputedStyle,
                      attrs: {
                        href: _vm.ctaUrl || "#",
                        target: _vm.ctaTarget || "_self",
                      },
                    },
                    [_vm._v(_vm._s(_vm.ctaText))]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "cms-nav-overlay-fade" } }, [
        _vm.isMobileLayout && _vm.mobileOpen
          ? _c(
              "div",
              {
                staticClass: "cms-nav__overlay",
                style: _vm.overlayBgStyle,
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    return _vm.closeMobile.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cms-nav__overlay-panel",
                    style: _vm.overlayPanelComputedStyle,
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cms-nav__overlay-header",
                        style: _vm.overlayHeaderStyle,
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "cms-nav__mobile-logo",
                            style: _vm.mobileLogoStyle,
                            attrs: { href: _vm.logoUrl || "/" },
                          },
                          [
                            _vm.resolvedLogoSrc
                              ? _c("img", {
                                  style: _vm.logoImgStyle,
                                  attrs: {
                                    src: _vm.resolvedLogoSrc,
                                    alt: _vm.siteName,
                                  },
                                })
                              : _c(
                                  "span",
                                  {
                                    staticClass: "cms-nav__mobile-sitename",
                                    style: _vm.mobileSitenameStyle,
                                  },
                                  [_vm._v(_vm._s(_vm.siteName || "Home"))]
                                ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "cms-nav__mobile-toggle",
                            style: _vm.mobileToggleStyle,
                            attrs: {
                              type: "button",
                              "aria-label": _vm.t("navigation.closeMenu"),
                            },
                            on: { click: _vm.closeMobile },
                          },
                          [_c("i", { staticClass: "fa fa-times" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "cms-nav__list cms-nav__list--mobile",
                        style: _vm.mobileListStyle,
                      },
                      _vm._l(_vm.mobileMenuItems, function (item) {
                        return _c(
                          "li",
                          {
                            key: "m-" + item.id,
                            staticClass: "cms-nav__mobile-item",
                            style: _vm.mobileItemStyle,
                          },
                          [
                            _c("div", { staticClass: "cms-nav__mobile-row" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "cms-nav__mobile-link",
                                  style: _vm.mobileLinkComputedStyle,
                                  attrs: {
                                    href: _vm.safeUrl(item.url),
                                    target: item.target || "_self",
                                  },
                                  on: { click: _vm.closeMobile },
                                },
                                [
                                  item.icon
                                    ? _c("i", { class: ["fa", item.icon] })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.label))]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasChildren(item)
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "cms-nav__mobile-expand",
                                      style: _vm.mobileExpandBtnStyle,
                                      attrs: {
                                        type: "button",
                                        "aria-expanded": _vm.mobileExpanded[
                                          item.id
                                        ]
                                          ? "true"
                                          : "false",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMobileItem(item.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          "fa",
                                          _vm.mobileExpanded[item.id]
                                            ? "fa-chevron-up"
                                            : "fa-chevron-down",
                                        ],
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.hasChildren(item) && _vm.mobileExpanded[item.id]
                              ? _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "cms-nav__list cms-nav__list--mobile-children",
                                    style: _vm.mobileChildListStyle,
                                  },
                                  _vm._l(
                                    _vm.flattenChildren(item),
                                    function (child) {
                                      return _c(
                                        "li",
                                        {
                                          key: "mc-" + child.id,
                                          staticClass:
                                            "cms-nav__mobile-item cms-nav__mobile-item--child",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              class: [
                                                "cms-nav__mobile-link",
                                                "cms-nav__mobile-link--child",
                                              ],
                                              style:
                                                _vm.mobileChildLinkStyle(child),
                                              attrs: {
                                                href: _vm.safeUrl(child.url),
                                                target: child.target || "_self",
                                              },
                                              on: { click: _vm.closeMobile },
                                            },
                                            [
                                              child.icon
                                                ? _c("i", {
                                                    class: ["fa", child.icon],
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(child.label)),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.ctaText
                      ? _c("div", { staticClass: "cms-nav__mobile-cta-wrap" }, [
                          _c(
                            "a",
                            {
                              staticClass: "cms-nav__mobile-cta",
                              style: _vm.mobileCTAStyle,
                              attrs: {
                                href: _vm.ctaUrl || "#",
                                target: _vm.ctaTarget || "_self",
                              },
                              on: { click: _vm.closeMobile },
                            },
                            [_vm._v(_vm._s(_vm.ctaText))]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "cms-nav-overlay-fade" } }, [
        _vm.searchOpen
          ? _c(
              "div",
              {
                staticClass: "cms-nav__search-modal",
                attrs: {
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-label": _vm.t("navigation.search"),
                },
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    return _vm.closeSearch.apply(null, arguments)
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape",
                      ])
                    )
                      return null
                    return _vm.closeSearch.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "cms-nav__search-form",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submitSearch.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-search cms-nav__search-icon",
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchQuery,
                          expression: "searchQuery",
                        },
                      ],
                      ref: "searchInput",
                      staticClass: "cms-nav__search-input",
                      attrs: {
                        type: "text",
                        placeholder:
                          _vm.searchPlaceholder ||
                          _vm.t("navigation.searchPlaceholder"),
                        autocomplete: "off",
                        "data-testid": "cms-nav-search-input",
                      },
                      domProps: { value: _vm.searchQuery },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchQuery = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "cms-nav__search-submit",
                        style: _vm.ctaComputedStyle,
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.t("navigation.search")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "cms-nav__search-close",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.t("navigation.closeSearch"),
                        },
                        on: { click: _vm.closeSearch },
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.cmsEditorContext && !_vm.resolvedItems.length && !_vm.hasMenuSelected
        ? _c("div", { staticClass: "cms-nav__empty" }, [
            _c("i", { staticClass: "fa fa-bars" }),
            _vm._v(" "),
            _c("span", [
              _vm._v("Select a menu in the sidebar to display navigation."),
            ]),
          ])
        : _vm.cmsEditorContext && !_vm.resolvedItems.length
        ? _c("div", { staticClass: "cms-nav__empty" }, [
            _c("i", { staticClass: "fa fa-bars" }),
            _vm._v(" "),
            _c("span", [_vm._v("This menu has no items yet.")]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }